module.exports = __webpack_public_path__ + "img/508.996ec77b.png";